import * as React from 'react';
import { useSelector } from 'react-redux';
import { identity } from 'ramda';

import { Section } from '../../../../components/Section';
import { MarketPriceContainer } from '../../../MarketPriceContainer';

import { TabsContainer } from '../../../TabsContainer';
import { AboutHomeContainer } from '../../../AboutHomeContainer';
import { useScrollingRef } from '../../../Scrolling';
import { EScrollingBlocks } from '../../../../constants/scrollingBlocks';
import { OffersHistoryContainer } from '../../../OfferHistory/Mobile';
import { ValuationContentContainer } from '../../../ValuationContentContainer';
import { selectDealType, selectIsWebview } from '../../../../selectors/page';
import { EstimationDealTypeBannerContainer } from '../../../EstimationDealTypeBannerContainer';
import { ObjectInfoContainer } from '../../../ObjectInfoContainer';
import { RateOurEstimationContainer } from '../../../RateOurEstimationContainer';
import { selectEstimationByDealType } from '../../../../selectors/estimation';
import { ErrorScreen } from '../../../../components/ErrorScreen';
import { MarketTrendsContainer } from '../../../MarketTrendsContainer';
import { MobileInfrastructureContainerLoad } from '../../../InfrastructureMapContainer';
import { OnbordingContainer } from '../../../OnbordingContainer';
import { HeroBanner } from '../../../../components/MyHome/HeroBanner';
import { MyHomeListingContainer } from '../../../MyHomeListingContainer';
import { ManagementCompanyContainer } from '../../../ManagementCompanyContainer';
import { BannerWrapper } from '../../../../components/BannerWrapper';
import { ServicesContainer } from '../../../ServicesContainer';
import { StatusList } from '../../../Status/containers/StatusList';
import { PrelandingContainer } from '../../../PrelandingContainer';
import { SubscribeWidgetContainer } from '../../../SubscribeWidget';

export function MyHomeMobilePage() {
  const isWebview = useSelector(selectIsWebview);
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const marketTrendsRef = useScrollingRef(EScrollingBlocks.MarketTrends);
  const dealTypeTabsRef = useScrollingRef(EScrollingBlocks.DealTypeTabs);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);
  const aboutHomeRef = useScrollingRef(EScrollingBlocks.AboutHome);
  const managementCompanyRef = useScrollingRef(EScrollingBlocks.ManagementCompany);

  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));
  if (estimation.isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      {!isWebview && (
        <HeroBanner>
          <MyHomeListingContainer />
        </HeroBanner>
      )}
      <ValuationContentContainer>
        <Section marginTop={28} marginBottom={32}>
          <TabsContainer refWrapper={dealTypeTabsRef} />
          <EstimationDealTypeBannerContainer />
        </Section>
        <Section>
          <ObjectInfoContainer refWrapper={identity} />
        </Section>
        <Section>
          <BannerWrapper />
        </Section>
        <Section>
          <OnbordingContainer />
        </Section>
        <Section marginBottom={48}>
          <MarketPriceContainer refWrapper={marketPriceRef} />
          <ServicesContainer />
          <RateOurEstimationContainer />
        </Section>
        <Section marginBottom={48}>
          <MarketTrendsContainer refWrapper={marketTrendsRef} />
        </Section>
        <Section marginBottom={48}>
          <OffersHistoryContainer refWrapper={offersHistoryRef} />
        </Section>
        <Section marginBottom={48}>
          <ManagementCompanyContainer refWrapper={managementCompanyRef} />
        </Section>
        <Section>
          <AboutHomeContainer refWrapper={aboutHomeRef} />
        </Section>
        <Section>
          <MobileInfrastructureContainerLoad refWrapper={infrastructureRef} />
        </Section>
      </ValuationContentContainer>
      <PrelandingContainer />
      <StatusList />

      <SubscribeWidgetContainer />
    </>
  );
}
